import React from 'react'

import { Dialog, snackbar } from 'components'
import { useApiCall } from 'hooks'

import { deleteTag } from '../api'

interface DeletePrizeDialogProps {
  handleClose: () => void
  onDone: () => void
  tagId: number
  tagTitle: string
}

const DeleteTagDialog: React.FC<DeletePrizeDialogProps> = ({
  handleClose,
  tagId,
  tagTitle,
  onDone,
}) => {
  const [deletePrizeApi, isLoading] = useApiCall<number, void>(deleteTag)

  const onDeletePrize = async () => {
    try {
      await deletePrizeApi(tagId)
      onDone()
    } catch (err) {
      console.error(err)
      snackbar.show('No se pudo eliminar la etiqueta(tag). Intente de nuevo.')
    }
  }

  return (
    <Dialog
      title={`¿Está seguro que desea eliminar la etiqueta(tag) "${tagTitle}"?`}
      isOpen
      showActions
      onCancel={handleClose}
      isLoading={isLoading}
      okButtonText="Eliminar"
      okButtonProps={{ disabled: isLoading }}
      onAccept={onDeletePrize}
    />
  )
}

export { DeleteTagDialog }
